import { render, staticRenderFns } from "./TrafficSummaryPanels.vue?vue&type=template&id=886d8fac&scoped=true&"
import script from "./TrafficSummaryPanels.vue?vue&type=script&lang=js&"
export * from "./TrafficSummaryPanels.vue?vue&type=script&lang=js&"
import style0 from "./TrafficSummaryPanels.vue?vue&type=style&index=0&id=886d8fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886d8fac",
  null
  
)

export default component.exports